// src/pages/profile/profile_componnent_edit/EditGender.jsx
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Stack,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import CustomButton from "../../../Components/CustomButton";

export default function EditGender({ initialGender, onCancel, onSubmit }) {
  const [genre, setGenre] = useState(initialGender || "");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setGenre(initialGender || "");
  }, [initialGender]);

  const handleSave = async () => {
    if (!genre) {
      setError(true);
      return;
    }
    setError(false);
    setLoading(true);
    try {
      await onSubmit({ genre });
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  return (
    <Stack spacing={2}>
      <Typography>Genre</Typography>
      <FormControl error={error && !genre}>
        <FormLabel>Genre</FormLabel>
        <RadioGroup
          value={genre}
          onChange={(e) => setGenre(e.target.value)}
        >
          <FormControlLabel value="Homme" control={<Radio />} label="Homme" />
          <FormControlLabel value="Femme" control={<Radio />} label="Femme" />
          <FormControlLabel
            value="Autre"
            control={<Radio />}
            label="Autre / Ne souhaite pas répondre"
          />
        </RadioGroup>
        {error && !genre && (
          <Typography variant="caption" color="error">
            Le genre est obligatoire
          </Typography>
        )}
      </FormControl>

      <Stack direction="row" justifyContent="flex-end" spacing={2}>
        <CustomButton type="secondaire" buttonText="Annuler" onClick={onCancel} />
        <CustomButton
          loading={loading}
          buttonText="Enregistrer"
          onClick={handleSave}
        />
      </Stack>
    </Stack>
  );
}

EditGender.propTypes = {
  initialGender: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
